import { showError } from "../utils/errorHandler";

export const icon = (value: string): boolean => {
  if (value === null) {
    return true;
  } else if (typeof value !== "string") {
    showError(`Icon has to be a string: ${typeof value} given.`);
    return false;
  } else if (value === "") {
    showError("Icon string can't be empty.");
    return false;
  }
  return true;
};
